import { createContext } from 'react'
import { AppAuthProviderContextValue } from '../types'

export const AppAuthContext = createContext<AppAuthProviderContextValue>({
    isAuthenticated: false,
})
